import { Row, Space } from "antd"
import { useEffect, useState } from "react"

import { Button } from "components/common"
import { CallButton } from "features/clients/components"
import PBXCallButton from "features/clients/components/pbx-call-button"
import WhatsappCallButton from "features/clients/components/whatsapp-call-button"
import { t } from "i18next"
import { useSelector } from "react-redux"
import getPrivilege from "utils/privileges/privileges"
import { configs } from "../../../../../configs"
import { PAGE_SUBSECTIONS, PAGES } from "../../../../../utils/gtm/gtmEventsData"
import MaqsamCallButton from "../../../../clients/components/maqsam-call-button"
import styles from "../../index.module.less"
import TsrAddTaskForm from "./tsrAddTaskForm/tsrAddTaskForm"
import TsrTabs from "./tsrTabs/tsrTabs"
import GrandStreamCallButton from "../../../../clients/components/grandStreamCallButton"

const TsrComponent = ({
  lead,
  client,
  activeKey,
  setActiveKey,
  buttonText,
  setButtonText,
  isFromAction,
  setIsFromAction,
}) => {
  const userInfo = useSelector(state => state?.app?.user.info)
  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    setFormVisibility()
  }, [lead?.id])

  const setFormVisibility = () => {
    setButtonText(isFromAction ? "Back" : "Add Task")
  }
  const onClickAddTaskButton = ({ isEditing = false }) => {
    setButtonText(text => (text == "Back" ? "Add Task" : "Back"))
    setIsEditing(isEditing)
    setActiveKey("tasks")
  }
  const canViewPbxCall = () => getPrivilege(["can_view_client_contact"], lead?.privileges) && !!userInfo?.pbxMachineId

  return (
    <>
      <Row justify="space-between" className={styles.drawerActionSticky}>
        <Space>
          {getPrivilege(["can_view_client_contact"], lead?.privileges) && (
            <>
              <WhatsappCallButton
                client={lead?.Client}
                text={t("Whatsapp")}
                from={{ interacted_from: "telesales_listings_page" }}
                shape="default"
                size="small"
              />
              {configs?.allowMaqsamCall && (
                <MaqsamCallButton
                  client={lead?.Client}
                  shape="default"
                  text={t("Call")}
                  from={{
                    page: PAGES.telesales_listing_page,
                    interacted_from: PAGE_SUBSECTIONS.telesales_listings_page,
                  }}
                  leadId={lead?.id}
                />
              )}
              {configs?.allowGrandStreamCall && (
                <GrandStreamCallButton
                  client={lead?.Client}
                  shape="default"
                  text={t("Grandstream")}
                  from={{
                    page: PAGES.telesales_listing_page,
                    interacted_from: PAGES.telesales_listing_page,
                  }}
                  leadId={lead?.id}
                />
              )}
              <CallButton
                text={t("Call")}
                client={lead?.Client}
                from={{ interacted_from: "telesales_listings_page" }}
                shape="default"
                size="small"
              />
            </>
          )}
          {canViewPbxCall() && <PBXCallButton text="Pbx" client={lead?.Client} shape="default" size="small" />}
        </Space>
        {getPrivilege(["can_add_task_on_lead"], lead?.privileges) && (
          <Button
            type={buttonText === "Back" ? "danger" : "primary"}
            size="small"
            onClick={onClickAddTaskButton}
            style={{ minWidth: 126 }}
          >
            {t(buttonText)}
          </Button>
        )}
      </Row>
      {!!(buttonText == "Add Task") && (
        <TsrTabs
          lead={lead}
          client={client}
          clientinLead={lead?.Client}
          onClickAddTaskButton={onClickAddTaskButton}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
        />
      )}
      {!!(buttonText == "Back") && (
        <TsrAddTaskForm
          lead={lead}
          buttonText={buttonText}
          client={client}
          setFormVisibility={setFormVisibility}
          isEditing={isEditing}
          isFromAction={isFromAction}
        />
      )}
    </>
  )
}
export default TsrComponent
